import { Config } from "@amtana/module";
import { z } from "zod";

// Where a mailed invite link points (S3.04): the platform's own origin, the
// same value auth's `PLATFORM_ORIGIN` already answers. One environment
// variable has exactly one owner (`packages/process/src/config.ts`'s
// `claimsOf`), so this cannot read that same name; it declares its own,
// prefixed by this module, with the same default (a decision in
// dev/docs/decisions.md). An operator pointing the platform at a real host
// sets both.
// Deleting with a grace period (S1.06): 14 days, the same window account's own
// deletion already uses; a scheduled task sweeps for anything past it once an hour.
export const ORGANIZATION_DELETION_GRACE_PERIOD_DAYS_DEFAULT = 14;
export const ORGANIZATION_PURGE_SWEEP_INTERVAL_MS_DEFAULT = 60 * 60 * 1000;

export const organizationConfig = Config.define((c) => ({
  platformOrigin: c.env("ORGANIZATION_PLATFORM_ORIGIN", z.url().default("http://127.0.0.1:4312")),
  deletionGracePeriodDays: c.env(
    "ORGANIZATION_DELETION_GRACE_PERIOD_DAYS",
    z.coerce.number().int().positive().default(ORGANIZATION_DELETION_GRACE_PERIOD_DAYS_DEFAULT),
  ),
  purgeSweepIntervalMs: c.env(
    "ORGANIZATION_PURGE_SWEEP_INTERVAL_MS",
    z.coerce.number().int().min(1000).default(ORGANIZATION_PURGE_SWEEP_INTERVAL_MS_DEFAULT),
  ),
}));
